// @flow
import styled from "styled-components";
import Icon from "../../_static/Icons";
import { buildText } from "../../_atom/Text";
import buildColor from "../../_static/ColorPalette";

export const DefaultBetContainer = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`;

export const DefaultSection = styled.div`
  background-color: ${buildColor("white", "100")};
  padding: 12px;
  margin-top: 12px;
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 768px) {
    padding: 20px;
    border-radius: 4px;
  }
`;

export const WagerSelectContainer = styled.div`
  position: relative;
  margin-top: 16px;

  @media only screen and (min-width: 768px) {
    width: 332px;
  }
`;

export const CustomBetListSection = styled.div`
  margin-top: 8px;
`;

export const BetGroupLine = styled.li`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
`;

export const CurrencySymbol = styled(
  buildText({
    fontSize: 14,
    color: buildColor("grey", "900")
  })
)`
  margin-left: 12px;
`;
